export default "/images/b44455b8d02d357f69f94d56f4a089cc.avif";